import {DataServiceBase} from "../DataServiceBase";

export class LongTermSavingsService extends DataServiceBase{
    constructor() {
        super('/SmartAccount/LongTermSavings/Get');
    }
}